<app-menu-section
  *ngFor="let list of employeeSections; trackBy: trackByItems"
  [list]="list"
  (clickLink)="goToPage($event)"></app-menu-section>
